<template>
  <div class="tasks-tabs">
    <ProjectTasksList
      :projects="projects"
      show-filters
      @change-responsible="handleChangeResponsible"
    />
  </div>
  <v-dialog v-model="showUserResponsibleProject">
    <v-card class="w-100" max-width="600">
      <v-card-title>
        <div class="text-subtitle-1 font-weight-bold">Назначить пользователя</div>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedUser"
          label="Пользователь"
          :items="availableUsers"
          variant="outlined"
          item-title="fullname"
          item-value="id"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" class="px-4" @click="handleCancelClick">Отмена</v-btn>
        <v-btn
          :disabled="isModalLoading"
          :loading="isModalLoading"
          variant="elevated"
          color="black"
          class="px-4"
          @click="changeResponsibleProject"
          >Назначить</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { v4 as uuidv4 } from 'uuid'
import TasksList from '@/components/Tasks/TasksList'
import { api } from '@/api/Api'
import { useToast } from '@/composables/useToast'
import NotesList from '@/components/Notes/NotesList.vue'
import ExpertiseList from '@/components/Expertise/ExpertiseList.vue'
import store from '@/store'
import ExpiredTasks from '@/components/Tasks/ExpiredTasks.vue'
import FutureTasks from '@/components/Tasks/FutureTasks.vue'
import ComplitedTasks from '@/components/Tasks/ComplitedTasks.vue'
import ProjectTasksList from '@/components/Tasks/ProjectTasksList.vue'

const { toast } = useToast()

const isExpert = computed(() => store.getters['user/isExpert'])
const isLoading = ref(false)
const tabs = ref([
  {
    id: uuidv4(),
    title: 'Все',
    component: TasksList,
  },
  {
    id: uuidv4(),
    title: 'Требуют действий',
    component: TasksList,
  },
  {
    id: uuidv4(),
    title: 'Отработаны',
    component: ComplitedTasks,
  },
  {
    id: uuidv4(),
    title: 'Просроченные',
    component: ExpiredTasks,
  },
  {
    id: uuidv4(),
    title: 'Будущие',
    component: FutureTasks,
  },
  {
    id: uuidv4(),
    title: 'Завершенные',
    component: TasksList,
  },
  {
    id: uuidv4(),
    title: 'Черновики',
    component: NotesList,
  },
])

const projects = ref([])
const points = ref([])
const showUserResponsibleProject = ref(false)
const isModalLoading = ref(false)
const selectedPoint = ref(null)
const selectedUser = ref(null)
const availableUsers = ref([])

async function getAllPoints() {
  isLoading.value = true

  try {
    await api
      .projects()
      .getAllPoints()
      .then((data) => {
        points.value = data
      })
  } catch (err) {
    console.log(err)
  } finally {
    isLoading.value = false
  }
}
async function getProjects() {
  isLoading.value = true
  try {
    await api
      .projects()
      .getProjectsList()
      .then((data) => {
        projects.value = data
      })
  } catch (err) {
    toast.error(err.message)
  } finally {
    isLoading.value = false
  }
}

async function handleChangeResponsible(pointId, responsibleUserId) {
  selectedPoint.value = pointId
  selectedUser.value = responsibleUserId

  const task = points.value.find((p) => p.id === pointId)
  if (!task) {
    toast.error('Задача не найдена')
    return
  }

  try {
    isLoading.value = true
    const projectData = await api.questionnaires().getProjectsById(task.projectId)
    availableUsers.value = projectData.users || []
    showUserResponsibleProject.value = true
  } catch (err) {
    toast.error('Не удалось загрузить список пользователей')
    console.log(err)
  } finally {
    isLoading.value = false
  }
}

async function changeResponsibleProject() {
  isModalLoading.value = true
  try {
    await api
      .projects()
      .changeResponsibleProject(selectedPoint.value, selectedUser.value)
      .then(() => {
        showUserResponsibleProject.value = false
        selectedPoint.value = null
        selectedUser.value = null
        getAllPoints()
        getProjects()
      })
  } catch (err) {
    if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message)
    }
  } finally {
    isModalLoading.value = false
  }
}

function handleCancelClick() {
  selectedPoint.value = null
  showUserResponsibleProject.value = false
}

const checkIsExpert = () => {
  if (isExpert.value) {
    tabs.value?.splice(3, 0, {
      id: uuidv4(),
      title: 'Экспертиза',
      component: ExpertiseList,
    })
  }
}

watch(isExpert, () => {
  checkIsExpert()
})

onMounted(() => {
  getProjects()
  getAllPoints()
  checkIsExpert()
})
</script>
<style lang="scss">
.tasks-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;

  .v-tab.v-tab {
    border-radius: 0;

    .v-btn__content {
      font-size: 14px;
      color: var(--color-neutral-darkest);
    }
  }

  .v-slide-group__content {
    border-bottom: 2px solid var(--table--light-border);
  }

  .v-expansion-panel-title {
    border: 1px solid var(--border-th-table);
    background: var(--background-thead-table);
    border-radius: 0;
  }
}

.filters {
  .v-field__input {
    min-height: 40px;
  }
  .v-field--variant-outlined {
    .v-field__outline__end {
      border-radius: 0 8px 8px 0;
    }

    .v-field__outline__start {
      border-radius: 8px 0 0 8px;
    }
  }
}
</style>
